import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { agreementPlanSchema, AgreementPlanFormValues } from "@modules/agreementPlans/validations";
import { useCreateAgreementPlanMutation } from "@modules/agreementPlans/services/mutations";

export function useAgreementPlanCreateForm() {
  const { mutateAsync, isPending } = useCreateAgreementPlanMutation();

  const methods = useForm<AgreementPlanFormValues>({
    resolver: zodResolver(agreementPlanSchema()),
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
